import { noop, type Subscription } from 'rxjs';
import { ajax } from 'rxjs/ajax';

import { type SlackMessage } from './model';

export const logMessage = (message: SlackMessage, webHookUrl: string): Subscription | undefined => {
  if (!webHookUrl) {
    return;
  }

  const { user, ...props } = message;
  const body = {
    attachments: [
      {
        ...props,
        footer: user.user_id,
      },
    ],
  };

  const req = {
    method: 'POST',
    url: webHookUrl,
    body: JSON.stringify(body),
    crossDomain: true,
  };

  // oxlint-disable-next-line consistent-return
  return ajax(req).subscribe(noop, (error) => console.error('Failed to post to Slack:', error.message));
};
